(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const controllers = new Map();
  const seen = new WeakSet();
  const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    if (!reduced.matches && !window.Shopify?.designMode) entry.target.animate(
      [{opacity:0, translate:'0 18px'}, {opacity:1, translate:'0 0'}],
      {duration:650, easing:'ease-out'});
    reveal.unobserve(entry.target);
  }), {threshold:0.08});
  function film(figure) {
    const video = figure.querySelector('video');
    const button = figure.querySelector('button');
    if (!video || !button) return () => {};
    let visible = false, paused = false;
    video.muted = true; video.loop = true; video.playsInline = true;
    video.controls = false; button.hidden = false;
    const label = () => {
      button.textContent = video.paused ? '▶' : 'Ⅱ';
      button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
    };
    const update = () => {
      if (!visible || paused || reduced.matches || document.hidden) video.pause();
      else video.play().catch(label);
      label();
    };
    const toggle = () => {
      if (video.paused) { paused = false; video.play().catch(label); }
      else { paused = true; video.pause(); }
      label();
    };
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting; update();
    }, {threshold:0.15});
    observer.observe(figure);
    button.addEventListener('click', toggle);
    video.addEventListener('play', label);
    video.addEventListener('pause', label);
    document.addEventListener('visibilitychange', update);
    reduced.addEventListener('change', update);
    label();
    return () => {observer.disconnect(); video.pause(); document.removeEventListener('visibilitychange', update); reduced.removeEventListener('change', update);};
  }
  function scan() {
    controllers.forEach((dispose, element) => {if (!element.isConnected) {dispose(); controllers.delete(element);}});
    document.querySelectorAll('[data-loop-film]').forEach(element => {if (!controllers.has(element)) controllers.set(element, film(element));});
    document.querySelectorAll('[data-reveal]').forEach(element => {if (!seen.has(element)) {seen.add(element); reveal.observe(element);}});
  }
  let scheduled = false;
  function parallax() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      document.querySelectorAll('.appetite-stage').forEach(stage => {
        const top = stage.getBoundingClientRect().top;
        stage.querySelectorAll('.hero-product').forEach((image, index) => {
          const shift = reduced.matches || innerWidth <= 760 ? 0 : Math.max(-46, Math.min(46, -top * [0.1,-0.06,0.08][index]));
          image.style.translate = '0 ' + shift + 'px';
        });
      });
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('.products-menu[open], .mobile-menu[open], .language-selector[open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.products-menu[open], .mobile-menu[open], .language-selector[open]').forEach(menu => {menu.open=false; menu.querySelector('summary').focus();});
  });
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', () => setTimeout(scan, 0));
  addEventListener('scroll', parallax, {passive:true});
  addEventListener('resize', parallax, {passive:true});
  reduced.addEventListener('change', parallax);
  scan();
})();
